import api from "@/apis/bussiness/mispAPI";
import Crud from "./crudBase";
var crud = new Crud("misp", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "event_uuid",
      code: "misp_event_id",      
    }
  },  
};
const getters = {
  ...crud.getters
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations  
};

export default {
  debug: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
